import { StorageHelper, StorageType } from "./storage";

export class LocalStorageHelper extends StorageHelper {
  public static init() {
    super.init();
    super.setStorage(localStorage, StorageType.LocalStorage);
  }
}

LocalStorageHelper.init();
